__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-shop-root'].baseUrl;
import { configureProductDucks } from 'axp-product-ducks';
import ModuleContainer from './components/AxpShopRoot';

/* istanbul ignore next */
configureProductDucks({
  getToState: state => state === null || state === void 0 ? void 0 : state.getIn(['modules', 'axp-shop-root', 'products'])
});
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/data-manager-utils': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.9',
      module: require('@americanexpress/data-manager-utils')
    },
    'axp-product-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.24',
      module: require('axp-product-ducks')
    },
    '@americanexpress/one-xp-client-sdk': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.35.1',
      module: require('@americanexpress/one-xp-client-sdk')
    },
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.5.4',
      module: require('@americanexpress/one-experiments')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.5',
      module: require('@americanexpress/react-ddl')
    },
    '@americanexpress/reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.8',
      module: require('@americanexpress/reactlytics')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-shop-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-shop-root';
}